var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124 86.657"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38",
    d: "M70.037 0h16.709C91.719 21.177 107.29 36.207 124 37.351v13.1c-16.711 1.128-32.111 15.045-37.086 36.206H70.037c3.8-18.578 13.244-30.713 26.822-37.663H0V37.662h97.01C83.281 29.746 73.837 16.157 70.037 0Z"
  })));
};
export default SvgArrow;